import type { ExternalLinkProvider } from '../../../../../hooks/requests/use-get-external-link';

const ORIGIN_LABELS: Record<ExternalLinkProvider, string> = {
  Hubspot: 'HubSpot',
  Salesforce: 'Salesforce',
};

/**
 * Formats the origin label shown on the contract page.
 *
 * Origin is derived from the contract's OWN CRM integration entities (not the
 * linked customer's source). A contract created manually in Vayu has no CRM
 * integration entity and is therefore "Vayu", even when its customer was
 * imported from a CRM.
 */
export function formatContractOrigin(provider: ExternalLinkProvider | null): string {
  if (provider === null) {
    return 'Vayu';
  }

  return ORIGIN_LABELS[provider];
}
